require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
require('../modules/es7.set.to-json');
require('../modules/es7.set.of');
require('../modules/es7.set.from');
module.exports = require('../modules/_core').Set;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/set.js
 ** module id = 552
 ** module chunks = 1
 **/